
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-9087.15 2949.35 14.301 14.3"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_252_1","data-name":"Symbol 252 – 1","transform":"translate(-10661 2335.5)","opacity":".87"}},[_c('g',{attrs:{"id":"Group_9358","data-name":"Group 9358"}},[_c('circle',{attrs:{"id":"Ellipse_903","cx":"6.5","cy":"6.5","r":"6.5","data-name":"Ellipse 903","transform":"translate(1574.5 614.5)","fill":"none","stroke-width":"1.3","stroke":"#f44336"}}),_c('g',{attrs:{"id":"Group_9357","data-name":"Group 9357","transform":"translate(1578.4 618.4)"}},[_c('path',{staticClass:"cls-3",attrs:{"id":"Line_1819","d":"M0 5.451L5.451 0","stroke":"#f44336","data-name":"Line 1819"}}),_c('path',{staticClass:"cls-3",attrs:{"id":"Line_1820","d":"M5.451 5.451L0 0","stroke":"#f44336","data-name":"Line 1820"}})])])])])
          )
        }
      }
    